import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProjectCategoryStoreActions,
  ProjectCategoryStoreSelectors,
  ProjectCategoryStoreReducer,
} from './index';
import { ProjectCategoryDto } from '@cradua/data';

@Injectable()
export class ProjectCategoryFacade {
  constructor(
    private store: Store<
      ProjectCategoryStoreReducer.ProjectCategoryPartialState
    >
  ) {}

  projectCategoryRecord$ = this.store.select(
    ProjectCategoryStoreSelectors.getSelected
  );
  projectCategoryRecordError$ = this.store.select(
    ProjectCategoryStoreSelectors.getProjectCategoryError
  );

  getselected() {
    return this.store.select(ProjectCategoryStoreSelectors.getSelected);
  }

  get isLoadingProjectCategory() {
    this.store.dispatch(ProjectCategoryStoreActions.loadProjectCategory());
    return this.store.select(
      ProjectCategoryStoreSelectors.loadingProjectCategory
    );
  }

  get loadProjectCategory() {
    this.store.dispatch(ProjectCategoryStoreActions.loadProjectCategory());
    return this.store.select(
      ProjectCategoryStoreSelectors.getAllProjectCategory
    );
  }

  addProjectCategory(newProjectCategory: ProjectCategoryDto[]) {
    this.store.dispatch(
      ProjectCategoryStoreActions.addProjectCategory({ newProjectCategory })
    );
  }

  updateProjectCategory(updateProjectCategory: ProjectCategoryDto[]) {
    this.store.dispatch(
      ProjectCategoryStoreActions.updateProjectCategory({
        updateProjectCategory,
      })
    );
  }

  removeProjectCategory(ids: string[]) {
    this.store.dispatch(
      ProjectCategoryStoreActions.removeProjectCategory({ ids })
    );
  }
}
